/* eslint-disable @typescript-eslint/no-explicit-any */

import { mapManager } from '../../map-manager'

type OverlayConstructor<TOverlay extends naver.maps.OverlayView, TOptions> = {
  new (options: TOptions): TOverlay
  prototype: TOverlay
}

export const createOverlay = <
  TOverlay extends naver.maps.OverlayView,
  TOptions,
>({
  base,
  initialize,
}: {
  base?: OverlayConstructor<naver.maps.OverlayView, any>
  initialize?: (this: TOverlay, options: TOptions) => void
}) => {
  const Overlay = function (this: TOverlay, options: TOptions) {
    if (base) {
      base.call(this, options)
    } else {
      naver.maps.OverlayView.call(this)
    }

    initialize?.call(this, options)

    mapManager.withMap(map => {
      this.setMap(map)
    })
  } as unknown as OverlayConstructor<TOverlay, TOptions>

  const OverlayView = base ?? naver.maps.OverlayView

  Overlay.prototype = Object.create(OverlayView.prototype) as TOverlay
  Overlay.prototype.constructor = Overlay

  return Overlay
}
